<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <h1 class="text-center">{{ category.name }}</h1>
    </v-row>
    <v-row align="center" justify="center">
      <h2>Participantes Edición 2024</h2>
    </v-row>
    <v-row align="center" justify="center">
      <v-col v-bind:key="nominee.id" v-for="nominee in nominees" cols="12" sm="12" md="12" lg="3" xl="3">
        <v-card class="pa-7 my-1 mx-2" @click="popVote(nominee)" outlined>
          <h3>{{ getCountryFlag(nominee.country) }} | {{ nominee.name }}</h3>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="3" xl="3">
        <v-card class="pa-7 my-1 mx-2" @click="goBack" color="grey lighten-2" flat>
          <h3>« Volver a Categorías</h3>
        </v-card>
      </v-col>
    </v-row>

    <!-- Overlay to vote for a nominee !-->
    <v-overlay v-model="overlayVote">
      <PopupVote v-if="currentNominee !== null" :nominee="currentNominee" @close="closePopup"/>
    </v-overlay>
  </v-container>
</template>

<script>
import Repository from '../../../repositories/award';
import Countries from '../../../assets/countries';
import PopupVote from "@/views/Awards/components/PopupVote";

export default {
  name: "CategoryNominees",
  components: {PopupVote},
  props: {
    category: Object,
  },
  data() {
    return {
      nominees: [],
      currentNominee: null,
      overlayVote: false,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if(this.category === undefined)
        this.$router.push('/vote');

      Repository.getAllNomineesOfCategory(this.category.id).then((response) => {
        if(response.status < 400)
          this.nominees = response.data;
      })
    },
    getCountryFlag(nomineeCountry) {
      let country = Countries.find((country) => country.key === String(nomineeCountry));
      return (country === undefined)? '🌎' : country.emoji;
    },
    popVote(nominee) {
      this.currentNominee = nominee;
      this.overlayVote = true;
    },
    goBack() {
      this.$router.push('/vote/award-categories');
    },
    closePopup() {
      this.overlayVote = false;
    }
  }
}
</script>

<style scoped>

</style>
